import { ActionTree } from 'vuex';
import * as types from './types';
import * as gtypes from '@/store/types'
import api from '@/modules/calendar/api';
//types
import { EnumCalendarViewType } from '@/modules/calendar/types';
import * as dateutil from '@/util/date-helper';
import accountState from '@account/store'
import colorArray from '@calendar/components/menu'
import { dispatchEventBus } from '@/util';


const batchCalendars: number[] = [1, 3, 4];
/**
 * 선택된 날짜가 데이터 리로드가 필요한 범위인지 검사합니다
 * @param state 일정 옵션 상태
 */
const isValidReloadFromChangedDate = function (state: calendar.state.CalendarState, forceType?: EnumCalendarViewType): boolean {
    let flag: boolean = false;

    const backDate: Date = state.backupDate.date;
    const curDate: Date = state.currentDate.date;
    const vmode: EnumCalendarViewType = forceType || state.calendarMode;

    switch (vmode) {
        case EnumCalendarViewType.Month:
            let mStart = dateutil.uGetMonthStartDate(backDate);
            let mEnd = dateutil.uGetMonthEndDate(backDate);
            flag = dateutil.uGetIsInDate(curDate, mStart, mEnd);
            break;
        case EnumCalendarViewType.Week:
            let wStart = dateutil.uGetWeekStartDate(backDate);
            let wEnd = dateutil.uGetWeekEndDate(backDate);
            flag = dateutil.uGetIsInDate(curDate, wStart, wEnd);
            break;
        case EnumCalendarViewType.Daily:
            flag = dateutil.uGetIsInDate(curDate, backDate, backDate);
            break;
    }

    return flag;
}
/**
 * 일정을 등록하거나 수정할 때 유효성을 검사합니다
 * @param item 일정 관련 저장 변수
 */
const validEvent = function (item: calendar.CalendarItem | null): string {
    let errMessage: string = '';

    if (!item?.subject) {
        errMessage = '제목이 비어있습니다';
    }
    else if (!item?.start) {
        errMessage = '시작기한이 비어있습니다';
    }
    else if (!item?.starttime) {
        errMessage = '시작시간이 비어있습니다';
    }
    else if (!item?.end) {
        errMessage = '완료기한이 비어있습니다';
    }
    else if (!item?.endtime) {
        errMessage = '완료시간이 비어있습니다';
    }
    else if (item.isAllDayEvent === false) {
        if (item.start == item.end && item.starttime == item.endtime) {
            errMessage = '시작일과 종료일이 동일할 수 없습니다';
        }

        if (dateutil.IEDate(item.start + ' ' + item.starttime) > dateutil.IEDate(item.end + ' ' + item.endtime)) {
            errMessage = '시작일이 종료일보다 클 수 없습니다';
        }
    }
    else if (!item.requiredAttendees && !item.requiredAttendees) {
        errMessage = "필수참석자를 선택해 주세요";
    }

    if (!item?.importance) {
        errMessage = '중요도를 선택해주십시오';
    }
    else if (item.requiredAttendees.length || item.optionalAttendees.length) {
        if ([...item.requiredAttendees, ...item.optionalAttendees].filter((x) => !x.address || x.address.indexOf('@') == -1).length) {
            errMessage = '참석자 메일주소가 잘못된 형식입니다';
        }
    }


    return errMessage;
}

const getCheckedFolderArr = function (folders: calendar.Folder[]): string[] {
    var returnArr: string[] = [];

    folders.forEach(f => {
        if(f.checked)
            returnArr.push(f.id);

        if(f.items) {
            var childArrs = getCheckedFolderArr(f.items as calendar.Folder[]);
            returnArr = [
                ...returnArr,
                ...childArrs
            ];
        }
    });

    return returnArr;
}

const findFolder = function (folders: calendar.Folder[], id: string): calendar.Folder | undefined {
    if (id) {
        for (let folder of folders) {
            if (folder.id === id) {
                return folder;
            } else if (folder.childFolderCount && folder.childFolderCount > 0) {
                let foundFolder = findFolder(folder.items || [], id);
                if (foundFolder) {
                    return foundFolder;
                }
            }
        }
    }
}

export default <ActionTree<calendar.state.CalendarState, RootState>>{

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M M O N : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    /**
     * 새로 회의실 목록, 미니캘린더, 캘린더 이벤트를 로드합니다
     * @param action 
     */
    [types.COMMON_REFRESH](action) {
        action.dispatch(types.COMMON_ROOM_LOAD);        
        action.dispatch(types.CALENDAR_EVENT_LOAD_LIST);
    },

    /**
     * 회의실 목록을 불러옵니다
     * @param action 
     */
    [types.COMMON_ROOM_LOAD](action) {
        return api.ews_resource.getRooms().then((res) => {
            action.commit(types.COMMON_ROOM_LOAD, res);
            action.commit(types.ADD_ACTION, 'ROOMS' as types.ACTION_TYPE);
        }).catch((err) => {
            debugger;
        });
    },

    /**
     * 현재 선택된 날짜의 상태에 따른 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.COMMON_DATE_SELECT](action, item: calendar.DateItem) {
        console.log('dateItem', item);
        action.commit(types.COMMON_DATE_SELECT, item);
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);
        if (!isValidReloadFromChangedDate(action.state)) {
            action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
            //action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            //action.commit(types.CALENDAR_WEEK_MATRIX_LOAD);
            action.commit(types.CALENDAR_DATE_MATRIX_LOAD);            
        }

        return action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
    },

    //20201112
    [types.COMMON_CHANGE_DATE](action, item: calendar.DateItem) {
        action.commit(types.COMMON_CHANGE_DATE, item);
        //action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);               
    },

    /**
     * '오늘'을 클릭할 경우 해당 날의 일별 이벤트를 불러옵니다
     * @param action 
     */
    [types.COMMON_DATE_SELECT_TODAY](action) {
        action.state.currentDate.date = new Date();
        action.state.currentCalendarDate.date = new Date();
        action.state.monthDate = new Date();
        action.dispatch(types.CALENDAR_MONTH_MATRIX_LOAD);        
        return Promise.all([
            action.dispatch(types.CALENDAR_EVENT_LOAD_LIST),
            action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST)
        ]);                
    },

    [types.CALENDAR_MAININIT](action) {
        action.state.currentDate.date = new Date();
        action.state.currentCalendarDate.date = new Date();
        action.state.monthDate = new Date();
        action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST)
    },

    /**
     * 월별보기에서 왼쪽화살표를 클릭 시 전 월의 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.COMMON_DATE_MONTH_PREV](action, item: calendar.DateItem) {
        action.commit(types.COMMON_DATE_MONTH_PREV, item);
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);

        if (!isValidReloadFromChangedDate(action.state)) {
            return action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
            action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            //action.commit(types.CALENDAR_WEEK_MATRIX_LOAD);
            //action.commit(types.CALENDAR_DATE_MATRIX_LOAD);
            return action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
        }
    },
    /**
     * 월별보기에서 오른쪽화살표를 클릭 시 다음 월의 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.COMMON_DATE_MONTH_NEXT](action, item: calendar.DateItem) {        
        action.commit(types.COMMON_DATE_MONTH_NEXT, item);
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);
        
        if (!isValidReloadFromChangedDate(action.state)) {
            return action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
            action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            //action.commit(types.CALENDAR_WEEK_MATRIX_LOAD);
            //action.commit(types.CALENDAR_DATE_MATRIX_LOAD);
            return action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
        }
    },

     /**
     * 일정 뷰에서 왼쪽화살표를 클릭 시 다음 월의 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
      [types.COMMON_CALENDAR_PREV](action, item: calendar.DateItem) {   
        const mode = action.state.calendarMode
        if (mode === EnumCalendarViewType.Month) {
            action.commit(types.COMMON_DATE_MONTH_PREV, item)
        } else if (mode === EnumCalendarViewType.Week) {
            action.commit(types.COMMON_DATE_WEEK_PREV, item)
        } else if (mode === EnumCalendarViewType.Daily) {
            action.commit(types.COMMON_DATE_DATE_PREV, item)
        }
        
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);
        
        if (!isValidReloadFromChangedDate(action.state)) {
            return action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
            action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            return action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
        }
    },

    /**
     * 일정 뷰에서 오른쪽화살표를 클릭 시 다음 월의 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
     [types.COMMON_CALENDAR_NEXT](action, item: calendar.DateItem) {   
        const mode = action.state.calendarMode
        if (mode === EnumCalendarViewType.Month) {
            action.commit(types.COMMON_DATE_MONTH_NEXT, item)
        } else if (mode === EnumCalendarViewType.Week) {
            action.commit(types.COMMON_DATE_WEEK_NEXT, item)
        } else if (mode === EnumCalendarViewType.Daily) {
            action.commit(types.COMMON_DATE_DATE_NEXT, item)
        }
        
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);
        
        if (!isValidReloadFromChangedDate(action.state)) {
            return action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
            action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            return action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
        }
    },

    /**
     * 월 선택 시 해당 월과 관련된 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.COMMON_DATE_SELECT_MONTH](action, item: calendar.DateItem) {
        action.commit(types.COMMON_DATE_SELECT_MONTH, item);
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);
        //action.commit(types.MINI_CALENDAR_MONTH_MATRIX_LOAD);
        if (!isValidReloadFromChangedDate(action.state)) {
            return action.dispatch(types.CALENDAR_EVENT_LOAD_LIST);     
        }
        else {
            return action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);            
        }

    },
    /**
     * 주별보기에서 왼쪽화살표를 클릭하면 전 주의 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.COMMON_DATE_WEEK_PREV](action, item: calendar.DateItem) {
        action.commit(types.COMMON_DATE_WEEK_PREV, item);
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);        

        if (!isValidReloadFromChangedDate(action.state)) {
            action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
            //action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            action.commit(types.CALENDAR_WEEK_MATRIX_LOAD);         
        }
    },
    /**
     * 주별보기에서 오른쪽화살표를 클릭하면 다음 주의 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.COMMON_DATE_WEEK_NEXT](action, item: calendar.DateItem) {
        action.commit(types.COMMON_DATE_WEEK_NEXT, item);
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);        

        if (!isValidReloadFromChangedDate(action.state)) {
            action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
            //action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            action.commit(types.CALENDAR_WEEK_MATRIX_LOAD);          
        }
    },
    /**
     * 일별보기에서 왼쪽 화살표를 클릭하면 다음 날의 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.COMMON_DATE_DATE_PREV](action, item: calendar.DateItem) {
        action.commit(types.COMMON_DATE_DATE_PREV, item);
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);        

        if (!isValidReloadFromChangedDate(action.state)) {
            return action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
           // action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            //action.commit(types.CALENDAR_WEEK_MATRIX_LOAD);
            action.commit(types.CALENDAR_DATE_MATRIX_LOAD);
            return action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
        }
    },
    /**
     * 일별보기에서 오른쪽 화살표를 클릭하면 다음 날의 이벤트를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.COMMON_DATE_DATE_NEXT](action, item: calendar.DateItem) {

        action.commit(types.COMMON_DATE_DATE_NEXT, item);
        action.state.monthDate = dateutil.IEDate(action.state.currentDate.date);        

        if (!isValidReloadFromChangedDate(action.state)) {
            return action.dispatch(types.CALENDAR_EVENT_LOAD_LIST); // 선택 날짜가 변경되면 이벤트 데이터 다시 불러오기        
        }
        else {
            //action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
            //action.commit(types.CALENDAR_WEEK_MATRIX_LOAD);
            action.commit(types.CALENDAR_DATE_MATRIX_LOAD);
            return action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
        }
    },

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: F O L D E R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    /**
     * 폴더 선택에 따른 이벤트 데이터를 불러옵니다
     * @param action 
     * @param item 
     */
    [types.FOLDER_SELECT](action, item: calendar.Folder) {
        action.commit(types.FOLDER_SELECT, item);
        action.dispatch(types.CALENDAR_EVENT_LOAD_LIST);
        action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
    },

    /**
     * 폴더와 관련된 내용과 이벤트(일정)를 불러옵니다
     * @param action 
     * @param parentId 
     */
    [types.FOLDER_LOAD_TREE](action, parentId?: string) {
        var personCode = accountState.state.current?.user == null ? '' : accountState.state.current.user.personCode;
        var comCode = accountState.state.current?.user == null ? '' : accountState.state.current.user.comCode;     

        let funcArr = [
            api.ews_folder.getMyFolderItems(parentId),
            api.ews_folder.getSharedFolders(),
            api.db_main.getCompanyFolderList({ personCode: personCode, comCode: comCode }),
            api.db_main.getDeptFolderList({ personCode: personCode })
        ] as Array<Promise<any>>;
        //action.commit(types.COMMON_LOADDING, true);
        return Promise.all(funcArr).then((resultArray) => {
            let itemList = [];
            let rootIdx = 0;
            for (let i = 0; i < resultArray.length; i++) {
                const items = resultArray[i];

                for (let j = 0; j < items.length; j++) {
                    const item = items[j];
                    item.root_index = rootIdx;
                    itemList.push(item);
                    rootIdx++;
                }
            }

            var data = {
                items: itemList,
                parentId: parentId
            };
            //action.commit(types.COMMON_LOADDING, false);
            action.commit(types.FOLDER_LOAD_TREE, data);
            action.commit(types.ADD_ACTION, 'FOLDERS' as types.ACTION_TYPE);            
        }).catch((e) => {
            console.log(e)
            //action.commit(types.COMMON_LOADDING, false);
        });
    },

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C A L E N D A R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //    

    /**
     * 선택된 캘린더
     * @param action 
     * @param eventId 
     */
    [types.CALENDAR_EVENT_SELECT_ID](action, eventId: string) {
        action.commit(types.CALENDAR_EVENT_SELECT_ID, eventId);
        action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
        action.dispatch(types.CALENDAR_WEEK_MATRIX_LOAD);
        action.dispatch(types.CALENDAR_DATE_MATRIX_LOAD);
    },

    [types.CALENDAR_DATE_SELECT](action, item: calendar.DateItem) {      
        action.commit(types.CALENDAR_DATE_SELECT, item);        
        action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST);
        action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
        action.dispatch(types.CALENDAR_WEEK_MATRIX_LOAD);
        action.dispatch(types.CALENDAR_DATE_MATRIX_LOAD);
    },

    /** 2
     * 캘린더의 월 매트릭스를 불러온다
     * @param action 
     */
    [types.CALENDAR_MONTH_MATRIX_LOAD](action) {       
        action.commit(types.CALENDAR_MONTH_MATRIX_LOAD);
        return action.state.calendarMonthMatrix;
    },
    /**
     * 뷰 모드가 주별보기로 바뀔 경우 주 매트릭스를 불러온다
     * @param action 
     */
    [types.CALENDAR_WEEK_MATRIX_LOAD](action) {
        if (action.state.calendarMode == EnumCalendarViewType.Week) {
            action.commit(types.CALENDAR_WEEK_MATRIX_LOAD);
        }
        return action.state.calendarWeekMatrix;
    },
    /**
     * 뷰 모드가 일별보기로 바뀔 경우 일 매트릭스를 불러옵니다
     * @param action 
     */
    [types.CALENDAR_DATE_MATRIX_LOAD](action) {
        if (action.state.calendarMode == EnumCalendarViewType.Daily) {
            action.commit(types.CALENDAR_DATE_MATRIX_LOAD);
        }
        return action.state.calendarDateMatrix;
    },
    /**
     * 캘린더에서 뷰 모드가 변경되면 미니달력과 이벤트 리스트를 갱신합니다
     * @param action 
     * @param viewType 캘린더 뷰 모드( 일 | 주 | 월 )
     */
    [types.CALENDAR_VIEWMODE_CHANGE](action, viewType: EnumCalendarViewType) {       
        if (viewType != EnumCalendarViewType.Month) {
            Object.assign(action.state.currentDate, action.state.currentCalendarDate);
        }

        action.commit(types.CALENDAR_VIEWMODE_CHANGE, viewType);
        return action.dispatch(types.FOLDER_LOAD_TREE)
            .then(res => {  
                var promiseArr = [
                    action.dispatch(types.CALENDAR_EVENT_LOAD_LIST)
                ];
                
                if(viewType === EnumCalendarViewType.Daily) {
                    promiseArr.push(action.dispatch(types.CALENDAR_DAILY_EVENT_LOAD_LIST));
                }

                return Promise.all(promiseArr);
            });        
    },
    /**
     * 캘린더에 이벤트(일정)를 추가합니다
     * @param action 
     */
    [types.CALENDAR_EVENT_ADD](action) {

        if (!action.state.newCalendar) {
            return;
        }
        
        const newCalendar = action.state.newCalendar;
        const { item } = newCalendar;     
        let errMessage: string = validEvent(item);

        if (item && !errMessage) {
            action.commit(types.COMMON_ERROR_CLEAR);

            if (item.isEWS) {
                const fields: mail.api.FieldOption[] = [
                    { key: 'Importance', value: item.importance },
                    { key: 'Subject', value: item.subject },
                    { key: 'Location', value: item.location },
                    { key: 'Start', value: item.start + 'T' + item.starttime },
                    { key: 'End', value: item.end + 'T' + item.endtime },
                    { key: 'IsAllDayEvent', value: item.isAllDayEvent },
                    { key: 'Body', value: item.body },
                    { key: 'RequiredAttendees', value: item.requiredAttendees },
                    { key: 'OptionalAttendees', value: item.optionalAttendees },
                    { key: 'Recurrence', value: item.recurrence },
                    { key: 'Resources', value: item.resources },
                    { key: 'Attachments', value: item.attachments },
                    { key: 'AttachmentKey', value: item.code },
                    { key: 'ReminderMinutesBeforeStart', value: item.reminderMinutesBeforeStart },
                ];
                const data: mail.api.DynamicApiOptions = {
                    fields: fields,
                    parentId: item.parentId,
                    type: 'Calendar'
                };
                //action.commit(types.COMMON_LOADDING, true);
                return api.ews_calendar.createEvent(data)
                    .then(async (res) => {
                        //action.commit(types.COMMON_LOADDING, false);
                        if (res) {
                            dispatchEventBus(window, 'calendar-add-result', res)
                            action.dispatch(types.FOLDER_LOAD_TREE);
                            action.dispatch(types.CALENDAR_EVENT_LOAD_LIST);                            
                            return true;
                        }
                        return res;
                    }).catch((err) => {
                        //action.commit(types.COMMON_LOADDING, false);
                        return false;
                    });
            } else {
                (item as any).PersonCode = action.rootState.$account?.current?.user.personCode;
                //action.commit(types.COMMON_LOADDING, true);
                return api.db_calendar.createCalendarEvent(item)
                    .then(async (res) => {
                        //action.commit(types.COMMON_LOADDING, false);
                        if (res) {
                            action.dispatch(types.FOLDER_LOAD_TREE);
                            action.dispatch(types.CALENDAR_EVENT_LOAD_LIST);                            
                            return true;
                        }
                    }).catch((err) => {
                        //action.commit(types.COMMON_LOADDING, false);
                        return false;
                    })
            }
        } else {
            action.commit(types.COMMON_ERROR_MESSAGE, errMessage);
        
            return false;
        }
    },
    /**
     * 캘린더 이벤트(일정)를 수정합니다
     * @param action 
     */
    [types.CALENDAR_EVENT_EDIT](action, item: calendar.CalendarItem) {       
        let errMessage: string = validEvent(item);
        console.log('errMessage', errMessage);
        if (!errMessage) {
            action.commit(types.COMMON_ERROR_CLEAR);
            if (item.isEWS) {
                const fields: mail.api.FieldOption[] = [
                    //{ key: 'ParentFolderId', value: item.parentId },
                    { key: 'Importance', value: item.importance },
                    { key: 'Subject', value: item.subject },
                    { key: 'Location', value: item.location },
                    { key: 'Start', value: item.start + 'T' + item.starttime },
                    { key: 'End', value: item.end + 'T' + item.endtime },
                    { key: 'IsAllDayEvent', value: item.isAllDayEvent },
                    { key: 'Body', value: item.body },
                    { key: 'RequiredAttendees', value: item.requiredAttendees },
                    { key: 'OptionalAttendees', value: item.optionalAttendees },
                    { key: 'Recurrence', value: item.recurrence },
                    { key: 'Attachments', value: item.attachments },
                    { key: 'Resources', value: item.resources },
                    { key: 'AttachmentKey', value: item.code },
                    { key: 'ReminderMinutesBeforeStart', value: item.reminderMinutesBeforeStart },
                ];

                const data: mail.api.DynamicApiOptions = {
                    fields: fields,
                    id: item.id,
                    type: 'Calendar'
                };
                //action.commit(types.COMMON_LOADDING, true);
                return api.ews_calendar.editEvent(data)
                    .then(async (res) => {
                        //action.commit(types.COMMON_LOADDING, false);
                        if (res) {
                            action.dispatch(types.FOLDER_LOAD_TREE);
                            action.dispatch(types.CALENDAR_EVENT_LOAD_LIST);
                            return true;
                        }
                        return res;
                    }).catch((err) => {
                        //return //action.commit(types.COMMON_LOADDING, false);                      
                    });
            } else {
                //action.commit(types.COMMON_LOADDING, true);
                (item as any).PersonCode = action.state.currentUser.id;
                return (item.appointmentType == 'Exception' ? api.db_calendar.updateRCalendarEvent(item) : api.db_calendar.updateCalendarEvent(item))
                    .then(async (res) => {
                        //action.commit(types.COMMON_LOADDING, false);
                        
                        if (res) {
                            action.dispatch(types.FOLDER_LOAD_TREE);
                            action.dispatch(types.CALENDAR_EVENT_LOAD_LIST);
                        }

                        return res;
                    }).catch((err) => {
                        //return //action.commit(types.COMMON_LOADDING, false);                   
                    });
            }
        } else {
            return action.commit(types.COMMON_ERROR_MESSAGE, errMessage);        
        }
    },
    
    /**
     * 해당 날짜와 관련된 이벤트 리스트를 불러옵니다
     * @param action 
     */
    [types.CALENDAR_DAILY_EVENT_LOAD_LIST](action) {
        if (action.state.calendarHideShow == true) {
            if (action.state.recursionFlags.CALENDAR_DAILY_EVENT_LOAD_LIST == 0 || true) {
                action.state.recursionFlags.CALENDAR_DAILY_EVENT_LOAD_LIST = 1;
                action.state.calendarDailyEvents = [];
                const currentDate = action.state.currentCalendarDate;
                const { date } = currentDate;

                let funcArr = [] as Array<Promise<any>>;
                // for (let i = 0; i < action.state.folders.mylist.items.length; i++) {
                //     const folder = action.state.folders.mylist.items[i];
                //     if (folder.checked) {
                //         funcArr.push(api.ews_calendar.getCalendarDailyEvents(folder.id, date));
                //     }
                // }

                let endDate: Date = new Date(date);
                endDate.setDate(endDate.getDate() + 1);

                funcArr.push(api.ews_calendar.getCalendarEventListWithRecurrence({
                    EwsFolderIDArray: action.state.folders.mylist.items.filter((x) => x.checked).map((x) => x.id),
                    StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', date),
                    EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', endDate),
                } as calendar.SearchOptions));

                let edate = new Date(date);
                edate.setDate(edate.getDate() + 1);
                //회사폴더와 관련된 아이템
                for (let i = 0; i < action.state.folders.companylist.items.length; i++) {
                    const folder = action.state.folders.companylist.items[i];
                    if (folder.checked) {
                        if(batchCalendars.indexOf(Number(folder.id)) >= 0) {
                            // funcArr.push(api.db_main.getCompanyDailyEventList({
                            //     FolderID: folder.id,
                            //     StartDate: dateutil.uGetDateOnly(date),
                            //     EndDate: dateutil.uGetDateOnly(endDate)
                            // }));
                        } else {
                            funcArr.push(api.db_main.getCalendarDailyEventList({
                                FolderID: folder.id,
                                StartDate: dateutil.uGetDateOnly(date),
                                EndDate: dateutil.uGetDateOnly(endDate),
                            }));
                        }                                                
                    }
                }

                //부서폴더와 관련된 아이템
                for (let i = 0; i < action.state.folders.deptlist.items.length; i++) {
                    const folder = action.state.folders.deptlist.items[i];
                    if (folder.checked) {
                        funcArr.push(api.db_main.getCalendarDailyEventList({
                            FolderID: folder.id,
                            StartDate: dateutil.uGetDateOnly(date),
                            EndDate: dateutil.uGetDateOnly(endDate),
                        }));
                    }
                }

                let events = [] as ItemList<calendar.CalendarItem>;
                return Promise.all(funcArr).then((resultArray) => {                            
                    return api.ews_calendar.getCalendarEventListWithRecurrence({
                        EwsFolderIDArray: action.state.folders.sharedlist.items.filter((x) => x.checked).map((x) => x.id),
                        StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', date),
                        EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', endDate),
                    } as calendar.SearchOptions).then((res) => {
                        for (let data of resultArray) {                            
                            for (let calendar of data) {                                
                                const existID = events.find((e) => (calendar.id != null && calendar.id == e.id) && (calendar.appointmentType != 'Occurrence' && calendar.appointmentType != 'Exception'));
                                let parentFolder: calendar.Folder | undefined = [
                                    ...action.state.folders.mylist.items,
                                    ...action.state.folders.companylist.items,
                                    ...action.state.folders.deptlist.items
                                ].find((e) => calendar.parentFolderId == e.id) as calendar.Folder;
                                    
                                // if(calendar.target === 'VC') 
                                //     parentFolder = findFolder(action.state.folders.viplist.items, calendar.parentFolderId);

                                if (existID || !parentFolder) {
                                    continue;
                                }

                                let event = calendar;
                                event.target = parentFolder.target;
                                event.parentName = parentFolder.displayName;
                                event.isEWS = parentFolder.isEWS;
                                event.color = !parentFolder.colorCode || parentFolder.colorCode == 'none' ? colorArray[parentFolder.root_index] : parentFolder.colorCode;
                                events.push(event);                                                          
                            }
                        }

                        for (let calendar of res) {
                            const existID = events.find((e) => calendar.id == e.id && (calendar.appointmentType != 'Occurrence' && calendar.appointmentType != 'Exception'));
                            let parentFolder = [
                                ...action.state.folders.sharedlist.items
                            ].find((e) => calendar.parentFolderId == e.id) as calendar.Folder;
                            if (existID || !parentFolder) {
                                if (parentFolder && parentFolder.isShared) {

                                } else {
                                    continue;
                                }
                            }

                            if (dateutil.uGetDateFormat('yyyy-MM-DD H:i:00', dateutil.IEDate(calendar.end)) == dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', endDate)) {
                                continue;
                            }
                            let event = calendar;
                            event.target = parentFolder.target;
                            event.isEWS = parentFolder.isEWS;
                            event.color = !parentFolder.colorCode || parentFolder.colorCode == 'none' ? colorArray[parentFolder.root_index] : parentFolder.colorCode;
                            events.push(event);
                        }

                        const sortFn = function (a: any, b: any): number {
                            return a == b ? 0 : a < b ? -1 : 1;
                        }

                        events.sort((a, b) =>
                            sortFn(Number(dateutil.IEDate(a.start)), Number(dateutil.IEDate(b.start))) ||
                            sortFn(Number(a.dateTimeCreated), Number(b.dateTimeCreated))
                        );
                                                
                        action.commit(types.CALENDAR_DAILY_EVENT_LOAD_LIST, events);
                        action.commit(types.ADD_ACTION, 'DAILYEVENTS' as types.ACTION_TYPE);
                        return events;
                    });
                })
            }
        }
    },
    /** 
     * 이벤트(일정) 리스트를 불러옵니다
     * @param action 
     * @param forceViewMode 캘린더 뷰 모드
     */
    [types.CALENDAR_EVENT_LOAD_LIST](action, forceViewMode?: EnumCalendarViewType) {
        if (action.state.recursionFlags.CALENDAR_EVENT_LOAD_LIST == 0 || true) {
            action.state.recursionFlags.CALENDAR_EVENT_LOAD_LIST = 1;
            action.state.calendarEvents = [];
            const currentDate = action.state.currentDate;
            const { date } = currentDate;
            //캘린더 뷰 타입에 따른 시작날짜를 불러옵니다
            const _getCurrentStartDate = function (date: Date, mdate: Date, viewType: EnumCalendarViewType) {
                switch (viewType) {
                    case EnumCalendarViewType.Daily:
                        return dateutil.uGetWeekStartPrev(date);
                        //return date;
                    case EnumCalendarViewType.Week:
                        return dateutil.uGetWeekStartDate(date);
                    case EnumCalendarViewType.Month:
                        //console.log('monArrStart', dateutil.uGetDaysInMonth(mdate)[0]);
                        return dateutil.uGetMonthStartPrev(mdate);
                }
                return date;
            }
            //캘린더 뷰 타입에 따른 끝날짜를 불러옵니다
            const _getCurrentEndDate = function (date: Date, mdate: Date, viewType: EnumCalendarViewType) {
                switch (viewType) {
                    case EnumCalendarViewType.Daily:
                        return dateutil.uGetWeekEndNext(date);
                        //return date;
                    case EnumCalendarViewType.Week:
                        let edate = dateutil.IEDate(date);
                        edate.setDate(edate.getDate() + 2);
                        return edate;
                    case EnumCalendarViewType.Month:
                        var endDate = dateutil.uGetMonthEndNext(mdate);
                        return endDate;
                }
                return date;
            }
            let funcArr = [] as Array<Promise<any>>;

            const start = dateutil.IEDate(_getCurrentStartDate(date, action.state.monthDate, forceViewMode || action.state.calendarMode));
            const end = dateutil.IEDate(_getCurrentEndDate(date, action.state.monthDate, forceViewMode || action.state.calendarMode));
            end.setDate(end.getDate() + 1);

            funcArr.push(api.ews_calendar.getCalendarEventListWithRecurrence({
                EwsFolderIDArray: action.state.folders.mylist.items.filter((x) => x.checked).map((x) => x.id),
                StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', start),
                EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', end),
            } as calendar.SearchOptions));

            for (let i = 0; i < action.state.folders.companylist.items.length; i++) {
                const folder = action.state.folders.companylist.items[i];
                if (folder.checked) {
                    if(batchCalendars.indexOf(Number(folder.id)) >= 0) {
                        funcArr.push(
                            api.db_main.getCalendarEventList({
                            // api.db_main.getCompanyEventList({
                              FolderID: folder.id,
                              StartDate: start,
                              EndDate: end,
                            })
                        )
                    } else {
                        funcArr.push(api.db_main.getCalendarEventList({
                            FolderID: folder.id,
                            StartDate: start,
                            EndDate: end
                        }));
                    }                    
                }
            }

            for (let i = 0; i < action.state.folders.deptlist.items.length; i++) {
                const folder = action.state.folders.deptlist.items[i];
                if (folder.checked) {
                    funcArr.push(api.db_main.getCalendarEventList({
                        FolderID: folder.id,
                        StartDate: start,
                        EndDate: end
                    }));
                }
            }

            let events = [] as ItemList<calendar.CalendarItem>;
            return Promise.all(funcArr).then((resultArray) => {
                api.ews_calendar.getCalendarEventListWithRecurrence({
                    EwsFolderIDArray: action.state.folders.sharedlist.items.filter((x) => x.checked).map((x) => x.id),
                    StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', start),
                    EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', end),
                } as calendar.SearchOptions).then((res) => {                   
                    for (let data of resultArray) {                       
                        for (let calendar of data) {
                            const existID = events.find((e) => ((calendar.id == e.id) && (calendar.id != null)) && (calendar.appointmentType != 'Occurrence' && calendar.appointmentType != 'Exception'));
                            let parentFolder: calendar.Folder | undefined = [
                                ...action.state.folders.mylist.items
                                , ...action.state.folders.companylist.items
                                , ...action.state.folders.deptlist.items
                            ].find((e) => calendar.parentFolderId === e.id) as calendar.Folder;                         

                            // if(calendar.target === 'VC') 
                            //     parentFolder = findFolder(action.state.folders.viplist.items, calendar.parentFolderId);

                            if (existID || !parentFolder) {
                                continue;
                            }

                            let event = calendar;
                            event.target = parentFolder.target;
                            event.isEWS = parentFolder.isEWS;
                            event.color = !parentFolder.colorCode || parentFolder.colorCode == 'none' ? types.COMMON_COLOR_ARRAY_GET(parentFolder.root_index) : parentFolder.colorCode;
                            events.push(event);
                        }
                    }

                    for (let calendar of res) {
                        const existID = events.find((e) => calendar.id == e.id && calendar.appointmentType != 'Occurrence');
                        let parentFolder = [
                            ...action.state.folders.sharedlist.items
                        ].find((e) => calendar.parentFolderId == e.id) as calendar.Folder;
                        if (existID || !parentFolder) {
                            if (parentFolder && parentFolder.isShared) {

                            } else {
                                continue;
                            }
                        }
                        let event = calendar;
                        event.target = parentFolder.target;
                        event.isEWS = parentFolder.isEWS;
                        event.color = !parentFolder.colorCode || parentFolder.colorCode == 'none' ? types.COMMON_COLOR_ARRAY_GET(parentFolder.root_index) : parentFolder.colorCode;
                        events.push(event);
                    }
                    const sortFn = function (a: any, b: any): number {
                        return a == b ? 0 : a < b ? -1 : 1;
                    }

                    events.sort((a, b) =>
                        sortFn(Number(dateutil.IEDate(a.start)), Number(dateutil.IEDate(b.start))) ||
                        sortFn(Number(a.dateTimeCreated), Number(b.dateTimeCreated))
                    );

                    action.commit(types.CALENDAR_EVENT_LOAD_LIST, events);                                
                    action.commit(types.ADD_ACTION, 'EVENTS' as types.ACTION_TYPE);
                    action.dispatch(types.CALENDAR_MONTH_MATRIX_LOAD); // 선택 날짜가 변경되면 큰달력 Matrix 데이터 다시 불러오기    
                    if (action.state.calendarMode == EnumCalendarViewType.Week) {
                        action.dispatch(types.CALENDAR_WEEK_MATRIX_LOAD);
                    } else if (action.state.calendarMode == EnumCalendarViewType.Daily) {
                        action.dispatch(types.CALENDAR_DATE_MATRIX_LOAD);
                    }
                    return events;
                });
            });
        }
    },

    /**
     * 검색한 캘린더 일정을 가져옵니다
     * @param action 
     * @param item 
     */
    [types.CALENDAR_SEARCH_LOAD](action, keyword: string) {

        let funcArr = [];
        let resultOption = {
            ...action.state.toolbar.search,
            Keyword: keyword
        } as calendar.SearchOptions;

        if (typeof resultOption.ParentFolderID === typeof '') {
            funcArr.push(api.ews_calendar.searchCalendarEventList(resultOption));
        }
        else if (typeof resultOption.ParentFolderID === typeof 0) {
            funcArr.push(api.db_main.searchCalendarEventList(resultOption));
        }
        else {
            resultOption.ParentFolderID = null;
            funcArr.push(api.ews_calendar.searchCalendarEventList(resultOption));
            funcArr.push(api.db_main.searchCalendarEventList(resultOption));
        }

        let events = [] as ItemList<calendar.CalendarItem>;
        let parentFolderArray = [
            ...action.state.folders.mylist.items
            , ...action.state.folders.companylist.items
            , ...action.state.folders.deptlist.items
        ];
        //action.commit(types.COMMON_LOADDING, true);
        return Promise.all(funcArr).then((resultArray) => {            
            for (let data of resultArray) {
                for (let calendar of data as any) {
                    const existID = events.find((e) => calendar.id === e.id);
                    let parentFolder = parentFolderArray.find((e) => calendar.parentFolderId === e.id) as calendar.Folder;
                    if (existID || !parentFolder) {
                        continue;
                    }
                    let event = calendar;
                    event.parentName = parentFolder.displayName;
                    event.target = parentFolder.target;
                    event.isEWS = parentFolder.isEWS;
                    event.color = !parentFolder.colorCode || parentFolder.colorCode == 'none' ? types.COMMON_COLOR_ARRAY_GET(parentFolder.root_index) : parentFolder.colorCode;
                    events.push(event);
                }
            }

            const sortFn = function (a: any, b: any): number {
                return a == b ? 0 : a < b ? -1 : 1;
            }

            events.sort((a, b) =>
                sortFn(Number(dateutil.IEDate(a.start)), Number(dateutil.IEDate(b.start))) ||
                sortFn(Number(a.dateTimeCreated), Number(b.dateTimeCreated))
            );

            //action.commit(types.COMMON_LOADDING, false);
            action.commit(types.CALENDAR_SEARCH_LOAD, events);
            action.commit(types.ADD_ACTION, 'SEARCHEVENTS' as types.ACTION_TYPE);
        }).catch((e) => {
            //action.commit(types.COMMON_LOADDING, false);
        });
    },

    /**
     * 반복일정 팝업 모달을 표시
     * @param action 
     * @param flag 
     */
    [types.CALENDAR_RECURRING_SHOW](action, flag: boolean) {
        action.commit(types.CALENDAR_RECURRING_SHOW, flag);
    },

    [types.COMMON_TOGGLE_CONTENTMASK](action, flag: boolean) {
        action.commit(types.COMMON_TOGGLE_CONTENTMASK, flag);
    }
};
